import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../commonFunctions";
  
  const createrc001 = {
    label: "Create Reconcilation Batch",
    pageLabel: "Create Reconcilation Batch",
    starting: true,
    url: "createrc001",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "General Ledger",
            name: "",
            description: "Enter General Ledger" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "General Ledger",
            name: "GeneralLedger",
            description: "General Ledger"
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: " ",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: " Date From-To",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "fromdate",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "todate",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "GL Balance",
            name: "",
            description: "" 
          }, 
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "glbalance",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Bank Balance",
            name: "",
            description: "" 
          }, 
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "Bankbalance",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
            
    ]
}
export default createrc001;